import { SolarProduct } from "../../../../model/solar-product/solar-product";
import ProductCard from "../../../provider/components/ProductCard";
import SolarProductDialog from "./SolarProductDialog";
import styles from "./SolarProviderDetails.module.scss";


export interface SolarProviderProductProps {
	products?: SolarProduct[];
}

const SolarProviderProduct: React.FC<SolarProviderProductProps> = ({ products }) => {
	

	return (
			<div className={styles.cards}>
				{products?.map((product: SolarProduct, index: number) => {
					return (
						<ProductCard
							key={index}
							product={product}
							dialog={<SolarProductDialog  />}
							showMenu
							triggerLoad={() => {}}
						/>
					);
				})}
			</div>
	);
};
export default SolarProviderProduct;
